var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("MeetingStarter", {
        attrs: { viewModel: _vm.meetingStarter },
        on: {
          startMeeting: _vm.StartMeeting,
          openSurvey: _vm.handleOpenPanelAccessCommand,
          closeSurvey: _vm.handleClosePanelAccessCommand,
          toggleAutoReveal: _vm.ToggleAutoRevealCommand,
          toggleNamesRevealed: _vm.ToggleNamesRevealedCommand,
          showAccessLinks: _vm.ShowAccessLinksCommand,
        },
      }),
      _vm._v(" "),
      _c("MeetingStopper", {
        attrs: { viewModel: _vm.meetingStopper },
        on: {
          stopMeeting: _vm.StopMeeting,
          openSurvey: _vm.handleOpenPanelAccessCommand,
          closeSurvey: _vm.handleClosePanelAccessCommand,
        },
      }),
      _vm._v(" "),
      _c("PanelOpener", {
        attrs: { viewModel: _vm.panelOpener },
        on: {
          "open-panel": _vm.handleOpenPanelAccessCommand,
          "show-links": _vm.ShowAccessLinksCommand,
        },
      }),
      _vm._v(" "),
      _c("PanelCloser", {
        attrs: { viewModel: _vm.panelCloser },
        on: { "close-access": _vm.handleClosePanelAccessCommand },
      }),
      _vm._v(" "),
      _c("SurveyAccessLinks", {
        attrs: { viewModel: _vm.surveyAccessLinks },
        on: {
          "send-email": _vm.handleSendEmailCommand,
          "download-links": _vm.downloadLinks,
        },
      }),
      _vm._v(" "),
      _c("AttributeDescriptionDialog", {
        attrs: { viewModel: _vm.attributeDescriptionDialog },
      }),
      _vm._v(" "),
      _c("AlternativeDetailsDialog", {
        attrs: { viewModel: _vm.alternativeDetailsDialog },
      }),
      _vm._v(" "),
      _c("DisagreementsDialog", {
        attrs: { viewModel: _vm.disagreementsDialog },
        on: { "switch-question": _vm.SwitchQuestion },
      }),
      _vm._v(" "),
      _c("PortfolioOrDecisionNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      !_vm.initialized
        ? _c("h3", [
            _c("i", { staticClass: "fa fa-spinner fa-spin" }),
            _vm._v(" Loading... "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.initialized && _vm.questionsCount === 0
        ? _c(
            "div",
            {
              staticClass: "d-flex justify-content-center",
              staticStyle: { "padding-top": "200px" },
            },
            [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("h5", { staticClass: "card-title" }, [
                    _vm._v("No questions"),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "card-text lead" }, [
                    _vm._v("Sorry. This panel has no questions."),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "sanitizedHref",
                          rawName: "v-sanitizedHref",
                          value: _vm.BackUrl,
                          expression: "BackUrl",
                        },
                      ],
                      staticClass: "btn btn-secondary",
                    },
                    [_vm._v("Go back")]
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.initialized && _vm.questionsCount > 0
        ? _c("div", [
            _c(
              "nav",
              {
                staticClass:
                  "navbar fixed-bottom navbar-dark bg-dark d-flex justify-content-center",
              },
              [
                _c(
                  "div",
                  { staticClass: "btn-group", attrs: { role: "group" } },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.PreviousQuestionCommand },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-chevron-left",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Prev question")]),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.AllQuestionsAnswered
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-warning",
                            attrs: {
                              type: "button",
                              title: "Go to next unanswered question",
                            },
                            on: { click: _vm.NextUnansweredQuestionCommand },
                          },
                          [
                            _vm._v(
                              "\n                    Next unanswered\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.AllQuestionsAnswered
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-success",
                            attrs: {
                              type: "button",
                              title: "Go to next unanswered question",
                            },
                            on: { click: _vm.AllDoneCommand },
                          },
                          [
                            _vm._v(
                              "\n                    All done\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.NextQuestionCommand },
                      },
                      [
                        _c("span", [_vm._v("Next question")]),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-chevron-right",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "container-fluid",
                staticStyle: { "padding-top": "130px" },
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _c("h6", { staticClass: "mx-5" }, [
                      _c(
                        "a",
                        {
                          directives: [
                            {
                              name: "sanitizedHref",
                              rawName: "v-sanitizedHref",
                              value: _vm.BackUrl,
                              expression: "BackUrl",
                            },
                          ],
                          staticClass: "text-dark",
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-angle-double-left",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" Back\n                        "),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "h1",
                      {
                        staticClass: "my-0 mx-5",
                        staticStyle: {
                          "font-size": "2em",
                          "font-weight": "300",
                          color: "#33475b",
                        },
                      },
                      [_vm._v("Panel: " + _vm._s(_vm.Name))]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-6 col-lg-5 text-right col align-self-end",
                    },
                    [
                      !_vm.MeetingStarted
                        ? _c("div", [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                attrs: { type: "button" },
                                on: { click: _vm.ShowMeetingStarterCommand },
                              },
                              [_vm._v("Start Meeting")]
                            ),
                            _vm._v(" "),
                            !_vm.SurveyStarted
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-secondary",
                                    attrs: { type: "button" },
                                    on: { click: _vm.ShowSurveyOpenerCommand },
                                  },
                                  [_vm._v("Open Survey")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.SurveyStarted
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-secondary",
                                    attrs: { type: "button" },
                                    on: { click: _vm.ShowSurveyCloserCommand },
                                  },
                                  [_vm._v("Close Survey")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-secondary",
                                attrs: { type: "button" },
                                on: { click: _vm.ShowAccessLinksCommand },
                              },
                              [_vm._v("Access links")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "btn-group" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary dropdown-toggle",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                Analyze votes\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click:
                                          _vm.ShowDisagreementsReportCommand,
                                      },
                                    },
                                    [_vm._v("Disagreements")]
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.MeetingStarted
                        ? _c("div", [
                            _c("div", { staticClass: "btn-group" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-warning",
                                  attrs: { type: "button" },
                                  on: { click: _vm.ToggleVotesRevealedCommand },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-regular fa-fw",
                                    class: _vm.VotesRevealed
                                      ? "fa-square-check"
                                      : "fa-square",
                                  }),
                                  _vm._v(
                                    " Reveal votes\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("button", {
                                staticClass:
                                  "btn btn-warning dropdown-toggle dropdown-toggle-split",
                                attrs: {
                                  type: "button",
                                  "data-toggle": "dropdown",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item px-1",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          $event.preventDefault()
                                          return _vm.ToggleAutoRevealCommand.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-regular fa-fw",
                                        class: _vm.AutoRevealEnabled
                                          ? "fa-square-check"
                                          : "fa-square",
                                      }),
                                      _vm._v(
                                        " Auto reveal\n                                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item px-1",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          $event.preventDefault()
                                          return _vm.ToggleNamesRevealedCommand.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-regular fa-fw",
                                        class: !_vm.NamesRevealed
                                          ? "fa-square-check"
                                          : "fa-square",
                                      }),
                                      _vm._v(
                                        " Anonymous\n                                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "btn-group" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary dropdown-toggle",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                Analyze votes\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click:
                                          _vm.ShowDisagreementsReportCommand,
                                      },
                                    },
                                    [_vm._v("Disagreements")]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "btn-group" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary dropdown-toggle",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                Actions\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: _vm.ShowMeetingStopperCommand,
                                      },
                                    },
                                    [_vm._v("Stop Meeting")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "dropdown-divider",
                                  }),
                                  _vm._v(" "),
                                  !_vm.SurveyStarted
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: _vm.ShowSurveyOpenerCommand,
                                          },
                                        },
                                        [_vm._v("Open Survey")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.SurveyStarted
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: _vm.ShowSurveyCloserCommand,
                                          },
                                        },
                                        [_vm._v("Close Survey")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: { click: _vm.ShowAccessLinksCommand },
                                    },
                                    [_vm._v("Access links")]
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("hr", {
                  staticStyle: {
                    "border-color": "#bbb",
                    margin: "20px 0 60px",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-lg-3 col-md-3 col-sm-4 col-xs-12",
                      staticStyle: { "padding-bottom": "100px" },
                    },
                    [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-header" }, [
                          _vm._v("\n                            Questions "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.ProgressDescription)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "float-right" }, [
                            _c(
                              "a",
                              {
                                staticClass: "text-dark",
                                on: { click: _vm.SwitchQuestionsOrderCommand },
                              },
                              [_vm._v(_vm._s(_vm.QuestionsOrderLabel))]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _vm.QuestionsOrder == 1
                            ? _c("div", [
                                _c("div", { staticClass: "dropdown" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "h5 dropdown-toggle",
                                      staticStyle: { "white-space": "normal" },
                                      attrs: { "data-toggle": "dropdown" },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.CurrentAttributeLabel)
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "dropdown-menu",
                                      staticStyle: {
                                        "max-height": "300px",
                                        "overflow-y": "auto",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "input-group px-3 mb-1",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.SearchPhrase,
                                                expression: "SearchPhrase",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "search",
                                              placeholder: "Search...",
                                            },
                                            domProps: {
                                              value: _vm.SearchPhrase,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.SearchPhrase =
                                                  $event.target.value
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _vm._m(0),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.AttributesView,
                                        function (attr) {
                                          return _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.SwitchToAttributeCommand(
                                                    attr
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(attr.Name) +
                                                  " "
                                              ),
                                              _c("br"),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "list-group mt-2" },
                                  _vm._l(_vm.QuestionsView, function (q) {
                                    return _c(
                                      "a",
                                      {
                                        staticClass:
                                          "list-group-item list-group-item-action",
                                        class: {
                                          "bg-secondary text-white":
                                            _vm.CurrentQuestionId ===
                                            q.QuestionId,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.SwitchToQuestionCommand(
                                              q
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", { class: _vm.getStatusCss(q) }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(q.AlternativeName)),
                                        ]),
                                        _vm._v(" "),
                                        q.GroupVoteValue != null
                                          ? _c("small", [
                                              _c("br"),
                                              _vm._v(
                                                "Value: " +
                                                  _vm._s(q.GroupVoteValue)
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.QuestionsOrder == 2
                            ? _c("div", [
                                _c("div", { staticClass: "dropdown" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "h5 dropdown-toggle",
                                      staticStyle: { "white-space": "normal" },
                                      attrs: { "data-toggle": "dropdown" },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.CurrentAlternativeLabel)
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "dropdown-menu",
                                      staticStyle: {
                                        "max-height": "300px",
                                        "overflow-y": "auto",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "input-group px-3 mb-1",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.SearchPhrase,
                                                expression: "SearchPhrase",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "search",
                                              placeholder: "Search...",
                                            },
                                            domProps: {
                                              value: _vm.SearchPhrase,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.SearchPhrase =
                                                  $event.target.value
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _vm._m(1),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.AlternativesView,
                                        function (a) {
                                          return _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.SwitchToAlternativeCommand(
                                                    a
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(a.Name)
                                              ),
                                              _c("br"),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "list-group mt-2" },
                                    _vm._l(_vm.QuestionsView, function (q) {
                                      return _c(
                                        "a",
                                        {
                                          staticClass:
                                            "list-group-item list-group-item-action",
                                          class: {
                                            "bg-secondary text-white":
                                              _vm.CurrentQuestionId ===
                                              q.QuestionId,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.SwitchToQuestionCommand(
                                                q
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            class: _vm.getStatusCss(q),
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(_vm._s(q.AttributeName)),
                                          ]),
                                          _vm._v(" "),
                                          q.GroupVoteValue != null
                                            ? _c("small", [
                                                _c("br"),
                                                _vm._v(
                                                  "Value: " +
                                                    _vm._s(q.GroupVoteValue)
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-lg-7 offset-lg-1 col-md-9 col-sm-8 col-xs-12",
                      staticStyle: { "padding-bottom": "100px" },
                    },
                    [
                      _vm.Question
                        ? _c("div", [
                            _c(
                              "p",
                              {
                                staticClass: "text-center lead",
                                staticStyle: { "font-size": "1.5rem" },
                              },
                              [
                                _vm._v(
                                  "\n                            How would you rate: "
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass: "text-primary",
                                    attrs: { title: "Show description" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.ShowAlternativeDetailsCommand(
                                          _vm.Question.AlternativeId
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.Question.AlternativeName))]
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                            in the context of: "
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass: "text-primary",
                                    attrs: { title: "Show description" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.ShowAttributeDetailsCommand(
                                          _vm.Question.AttributeId
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.Question.AttributeName))]
                                ),
                                _vm._v("?\n                        "),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "card card-collapsable mt-1" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-header pointer",
                                    attrs: {
                                      "data-toggle": "collapse",
                                      href: "#cardQuestion",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Group vote\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "card-body collapse show pt-4",
                                    attrs: { id: "cardQuestion" },
                                  },
                                  [
                                    _c("HostVoteEditor", {
                                      attrs: { readModel: _vm.Question },
                                      on: {
                                        "update-comment": _vm.saveComment,
                                        "update-value": _vm.saveValue,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "mt-3" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "mt-4",
                                  staticStyle: { "min-height": "500px" },
                                },
                                [
                                  _c("VotesBrowser", {
                                    attrs: {
                                      AlternativeName:
                                        _vm.Question.AlternativeName,
                                      HasScale: _vm.Question.HasScale,
                                      Entries: _vm.Question.Entries,
                                      ScaleLevels: _vm.Question.ScaleLevels,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", {
          staticClass: "fa-solid fa-magnifying-glass",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", {
          staticClass: "fa-solid fa-magnifying-glass",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }